import {memo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {ClientReportSubmitInput, VinelandIncludedOptionsMap} from "../domain";
import {SimpleDropdown} from "common";

type VinelandIncludedInputProps = {
    disabled: boolean;
};
export const VinelandIncludedInput = memo(({
                                               disabled
                                           }: VinelandIncludedInputProps) => {
    const {
        setValue,
        clearErrors,
        control,
        formState: {
            errors
        },
    } = useFormContext<ClientReportSubmitInput>();

    return (
        <div>
            <div className="flex text-black-200 pb-2 items-center text-base">
                <div className="w-2/6 text-right">
                    Vineland Included
                </div>
                <div className="ml-4 flex items-center">
                    <Controller
                        name="vinelandIncluded"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={({field: {value}}) =>
                            <SimpleDropdown
                                options={VinelandIncludedOptionsMap}
                                selected={value}
                                disabled={disabled}
                                hasErrorBorder={errors.vinelandIncluded !== undefined}
                                setSelected={(selected) => {
                                    setValue("vinelandIncluded", selected);
                                    clearErrors("vinelandIncluded");
                                }}
                                textColor={"black-200"}
                            />
                        }/>
                </div>
            </div>
            {
                errors.vinelandIncluded &&
                <div className="flex">
                    <div className="w-2/6"/>
                    <div className="ml-4 text-red-700">
                        Please select “Vineland Included” before submitting the report
                    </div>
                </div>
            }
        </div>
    );
});
